import { ProcessFlowStepStoreState } from '../../store/processFlow/types';

export const getStepIndexByName = (steps: ProcessFlowStepStoreState[], stepName: string): number => {
	const step = steps.find((elem: ProcessFlowStepStoreState) => elem.name === stepName);

	return !step ? -1 : step.index;
};

export const getFlowUrlByName = (flows: { [key: string]: any }, flowName: string): string => {
	const flow = flows[flowName];

	return flow ? flows[flowName].path : undefined;
};
